import {Message} from 'element-ui';

function copy_success() {
  Message({
    message: 'Successfully copied!',
    type: 'success',
    duration: 1000
  })
}
export {copy_success}
